import { Descriptions, Form, Spin, Tree } from 'antd'
import { useEffect, useState } from 'react'
import RoleService from '../../../@services/role'

const permissions2TreeDataFilter = (data, ids) => {
  const loopTree = (tree, parent) => {
    return (tree || []).filter(item => {
      item.title = item.name
      item.key = item.id
      item.isChecked = ids.includes(item.id)
      if (parent && item.isChecked) {
        parent.isChecked = item.isChecked
      }
      if (item.children && item.children.length) {
        item.children = loopTree(item.children, item)
      }
      return item.isChecked
    })
  }
  return loopTree(data)
}

const TreeCheck = props => {
  const treeProps = { ...(props || {}) }
  if (props.value) {
    treeProps.checkedKeys = props.value
  }
  return (
    <Spin spinning={treeProps.loading}>
      <Tree {...treeProps} onCheck={treeProps.onChange} />
    </Spin>
  )
}

export default function FormPage(props) {
  const { originForm } = props
  const [form] = Form.useForm(originForm)

  const [treeProps, setTreeProps] = useState({
    treeData: [],
    autoExpandParent: true,
    loading: false,
    expandedKeys: [],
    showLine: true,
  })

  const [role, setRole] = useState({})
  useEffect(() => {
    const info = form.getFieldsValue() || {}
    setRole(info)
  }, [form])

  useEffect(() => {
    const getPermissionsTree = async () => {
      try {
        setTreeProps(state => ({ ...state, loading: true }))
        const res = await RoleService.getPermissionsTree()
        const info = form.getFieldsValue() || {}
        info.permissions = info.permissions || []
        const tree = permissions2TreeDataFilter(res, info.permissions)
        
        setTreeProps(state => ({
          ...state,
          treeData: tree,
          expandedKeys: info.permissions || [],
        }))
      } catch (error) {
        console.log({ error })
      } finally {
        setTreeProps(state => ({ ...state, loading: false }))
      }
    }
    getPermissionsTree()
  }, [form])

  return (
    <Form
      form={form}
      initialValues={{ state: true }}
    >
      <Descriptions
        bordered
        column={1}
        size={'small'}
        labelStyle={{ width: '90px' }}
      >
        <Descriptions.Item label="角色名称">
          <Form.Item name="name" style={{ marginBottom: 0 }}>
            {role.name}
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="权限菜单">
          <Form.Item name="permissions" style={{ marginBottom: 0 }}>
            <TreeCheck
              {...treeProps}
              style={{ maxHeight: '200px', overflow: 'auto' }}
            />
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="备注">
          <Form.Item name="description" style={{ marginBottom: 0 }}>
            {role.description}
          </Form.Item>
        </Descriptions.Item>
      </Descriptions>
    </Form>
  )
}
